/**
 * 工具函数封装
 */
export function formateDate(date, rule) {
    let fmt = rule || 'yyyy-MM-dd hh:mm:ss'
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, date.getFullYear())
    }
    const o = {
        // 'y+': date.getFullYear(),
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    }
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            const val = o[k] + '';
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? val : ('00' + val).substr(val.length));
        }
    }
    return fmt;
}

//动态加载外部js
//@param RESOURCE_LIST 外部地址集合["address"]
export function loadVoLteResourceList (RESOURCE_LIST,success) {
    return new Promise(r=>{
      RESOURCE_LIST.reduce((res, el) => res.then(() => loadScript(el)), Promise.resolve()).then(() => {
        r()
      }).catch((error) => {
        console.error('外呼VoLTE sdk 前置 js 资源加载失败:', error.name, error.message)
        return Promise.reject(error)
      })
    })
  }
  
  export function loadScript (url) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script')
  
      script.onload = () => resolve()
  
      script.onerror = () => reject(new Error(`Load script from ${url} failed`))
  
      script.src = url
      const head =
          document.head || document.getElementsByTagName('head')[0]
        ;(document.body || head).appendChild(script)
    })
}
// 字符串驼峰正则
export function transformStr3 (str) {
    let re = /_(\w)/g
    return str.replace(re, ($0,$1) => {
        return $1.toUpperCase()
    })
}

export function formatToLine (value) {
return value.replace(/([A-Z])/g, '_$1').toLowerCase()
}

// 表单行ID接口格式化
export function getformDetailitemsdata (data) {
    let typekey = 'val'
    if (!data.values) return ''
    return data.values.length > 0 ?
    data.compt === 'imagebox' ?
    data.values :
    data.values[0][typekey] : ''
}

let comptVal = ['editinput', 'edittextarea', 'autonumber', 'numberinput', 'dateinput', 'radiobutton', 'selectbox', 'richtext', 'areamultiselect', 'multipleselect', 'signature']
// 表单列表ID接口格式化 兼容数组
export function getformListItemsdatas (data) {
    // 若groupValues或 values有多个 则返回数组
    // 否则 先判断是compt返回结构是val 直接返回val数据 否则返回数组
    let formatItem = ''
    if (!data.groupValues) return ''
    if (data.groupValues.length > 1) {
        formatItem = data.groupValues
    } else {
        formatItem = data.groupValues[0].values ? data.groupValues[0].values.length > 1 ? data.groupValues[0].values : data.groupValues[0].values[0] : ''
    }
    if (formatItem.length && formatItem.length === 1) {
        let isVal = false
        let isHasVal = comptVal.filter(item => data.compt === item)
        if (isHasVal.length > 0) {
            isVal = true
            return formatItem[0].val !== '' ? formatItem[0].val : ''
        }
        if (!isVal) return formatItem
    } else {
        return formatItem
    }
}

// 表单列表ID接口格式化
export function getformListItemsdata (data) {
    let typekey = 'val'
    if (!data.groupValues) return ''
    if (!data.groupValues[0].values) return ''
    if (!data.groupValues[0].values[0].length === 0) return ''
    if (data.compt === 'imagebox') typekey = 'fileUrl'
    return data.groupValues[0].values[0].length && data.groupValues[0].values[0][0] ? data.groupValues[0].values[0][0][typekey] : ''
}


// 处理请求协议
export function handleHttp (val) {
    let currenthttp = location.protocol
    return val.indexOf(currenthttp) > -1 ? val : val.replace(val.match(/(\S*)\/\//i)[1], currenthttp)
}
export function getImg (el) {
  return handleHttp(`${location.protocol}//museum.chaoxing.com/star3/origin/${el.objectId}.${el.suffix}`)
}

// formdata构造返回数据函数
export function getformdata (data, val) {
    if (!data.values) return ''
    if (!data.values[0]) return ''
    if (!data.values[0][0]) return ''
    if (val !== undefined) {
        return val === 'fileUrl' || 'playUrl' ? handleHttp(data.values[0][0][val]) : data.values[0][0][val]
    } else {
        return data.values[0][0].val !== '' ? data.values[0][0].val : ''
    }
}

// formdataList构造返回数据函数
export function getformdataList (data, val) {
    if (!data.values) return ''
    if (!data.values[0]) return ''
    if (data.compt == 'imagebox') return `https://museum.chaoxing.com/star3/origin/${data.values[0].objectId}.${data.values[0].suffix}`
    return data.values[0].val !== '' ? data.values[0].val : ''
}

// 字节转换
export function sizeFilter($bytesize) {
    let $i = 0
    // 当$bytesize 大于是1024字节时，开始循环，当循环到第4次时跳出；
    while (Math.abs($bytesize) >= 1024) {
      $bytesize = $bytesize / 1024
      $i++
      if ($i === 4) break
    }
    // 将Bytes,KB,MB,GB,TB定义成一维数组；
    const $units = ['Bytes', 'KB', 'MB', 'GB', 'TB']
    const $newsize = Math.round($bytesize, 2)
    return $newsize + $units[$i]
}

// 处理表单文件字段添加/编辑数据格式
export function formfileHandle (data, name, uid) {
    return data.map(item => {
        let newObj = {
            name: item.name,
            objectId: item.objectid || item.objectId,
            byteSize: item.byteSize || item.size,
            size: item.byteSize ? item.size : sizeFilter(item.size),
            suffix: item.suffix ? item.suffix : item.name.split('.')[1],
            fileUrl: handleHttp(`https://pan-yz.chaoxing.com/thumbnail/origin/${item.objectid || item.objectId}`),
            modifyDate: new Date().getTime(),
            resid: '',
            puid: uid
        }
        // handleHttp(item.http)
        if (name && name === 'videobox') {
            newObj.fileUrl = ''
            newObj.duration = ''
            newObj.videoHeight = 0
            newObj.videoWidth = 0
        }
        if (name && name === 'fileupload') newObj.fileUrl = ''
        return newObj
    })
}

// 表单字段获取默认值 判断
export function getdefaultVal (item) {
    return item.compt === 'selectbox' || item.compt === 'radiobutton'
}

// 表单判断文件字段（图片/文件上传/视频）
export function getFileStatus (item) {
    return item.compt === 'imagebox' || item.compt === 'fileupload' || item.compt === 'videobox'
}

// 判断在微信的什么环境
export function isWx () {
    let ua = navigator.userAgent.toLowerCase()
    if (ua.indexOf('micromessenger') > -1) {
      return new Promise(resolve => {
        if (ua.indexOf('miniprogram') > -1) {
          resolve('mini-wx')
        } else {
          resolve('wx')
        }
      })
    } else {
      return new Promise(resolve => {
        resolve('no-wx')
      })
    }
}

// 插入字符
export function insertStr (str, index, insertStr) {
    return str.substring(0, index) + insertStr + str.substring(index)
}

// 处理颜色
export function colorConfig (data, name) {
    let tl = data
    tl = tl.replace(/\uff08/g, '(')
    tl = tl.replace(/\uff09/g, ')')
    tl = tl.includes('(') ? tl.split('(')[1].replace(')', '') : tl
    document.documentElement.style.setProperty(name, tl)
}

// 处理图片大小
export function setImgsize(data, width, height) {
    // console.log(data)
    if (!data) return
    // https://p.ananas.chaoxing.com/star3/780_636cQ100/3f19f362ba96097d25c7bb7a2b7f4d0c.jpg
    let fileUrl = `${location.protocol}//p.ananas.chaoxing.com/star3/${width}_${height}cQ100/${data.objectId}.${data.suffix}`
    return fileUrl
}

// 处理图片大小
export function locationHandle(detail, url) {
    if (url !== undefined) {
        // 处理前期没有route字段
        let locationurl = ''
        let newLng = ''
        let newLat = ''
        if (url.location !== undefined) {
            locationurl = url.location.replace(/，/, ',')
            let splitlUlr = locationurl.split(',')
            newLng = Number(splitlUlr[0])
            newLat = Number(splitlUlr[1])
        } else {
            locationurl = url.route[0].lng + ',' + url.route[0].lat
            // console.log(url.route[0])
            newLng = Number(url.route[0].lng)
            newLat = Number(url.route[0].lat)
        }
        let newUrl = ''
        if (document.body.clientWidth < 768) {
            newUrl = 'https://m.amap.com/share/index/lnglat=' + locationurl + '&name=' + detail.placeName + '&src=uriapi&innersrc=uriapi'
        } else {
            newUrl = handleHttp('http://map.baidu.com/?latlng=' + newLat + ',' + newLng)
        }
        
        isWx().then(type => {
            if (type === 'mini-wx') {
                wx.miniProgram.navigateTo({
                    url: '/pages/location/location?longitude=' + newLng + '&latitude=' + newLat + '&name= ' + detail.placeName
                })
            } else {
                if (detail.linkTarget !== undefined && detail.linkTarget === '是') {
                    window.open(newUrl)
                } else {
                    this.linkcontainerflag = true
                    this.iframeurl = newUrl
                }
            }
        })
    }
}

// 计算两个时间差 返回小时
export function hoursBetween(timestamp1, timestamp2) {
    const date1 = new Date(timestamp1)
    const date2 = new Date(timestamp2)
    const diff = Math.abs(date2 - date1) // 计算两个日期之间的差值（毫秒）
    return diff / (1000 * 60 * 60) // 转换为小时
}
/*
** 格式化数据
*/
export function getformitemsdata (data) {
  switch (data.compt) {
    case 'imagebox' ||
    'datetimerange' ||
    'checklist' ||
    'imagechecklist' ||
    'selectmultibox' ||
    'contact' ||
    'belonger' ||
    'department' ||
    'computeinput' ||
    'location' ||
    'livevideo' ||
    'fileupload' ||
    'videobox' ||
    'areacheckbox' ||
    'button':
      return data.values.length ? data.values : []
      break
    default:
      return data.values.length && data.values[0] ? data.values[0].val : ''
      break
  }
}